document.addEventListener("firstDateReady", function(e) {
  // Normalize the received Date into UK midnight
  const raw = new Date(e.detail.date); 
  const firstAvailableUK = new Date(
    new Date(raw).toLocaleString("en-US", { timeZone: "Europe/London" })
  );
  firstAvailableUK.setHours(0, 0, 0, 0);

    window.firstAvailableUK = firstAvailableUK;

  // Build today/tomorrow in UK timezone
  const nowUK = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/London" }));
  nowUK.setHours(0, 0, 0, 0);

  const todayUK = new Date(nowUK);
  const tomorrowUK = new Date(nowUK);
  tomorrowUK.setDate(todayUK.getDate() + 1);

  // Helper: format dd-mm-yy to match metafield
  function formatDate(d) {
    const day = ("0" + d.getDate()).slice(-2);
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const year = d.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  }

  // Helper: check if date is in unavailable list
  function isUnavailable(d) {
    return (window.unavailableDates || []).includes(formatDate(d));
  }

  const todayCard = document.querySelector('.delivery-card[data-type="today"]');
  const tomorrowCard = document.querySelector('.delivery-card[data-type="tomorrow"]');
  const customCard = document.querySelector('.delivery-card[data-type="custom"]');

  let hiddenCount = 0;

  // ✅ Keep original today logic
  if (todayCard && firstAvailableUK > todayUK) {
    todayCard.style.display = "none";
    hiddenCount++;
  }

  // ✅ Tomorrow logic: only hide if tomorrow is in unavailable dates
  if (tomorrowCard && isUnavailable(tomorrowUK)) {
    tomorrowCard.style.display = "none";
    hiddenCount++;
  }

  // Auto-open custom if both hidden
  if (hiddenCount === 2 && customCard) {
    customCard.classList.add("active");
    const input = customCard.querySelector("input#delivery_date_picker");
    if (input) input.focus();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // ---------- Helpers ----------
  function closeAllAccordionContents(exceptContent = null) {
    document.querySelectorAll('.accordion-item').forEach(item => {
      const content = item.querySelector('.accordion-content');
      const header = item.querySelector('.accordion-header');
      if (!content) return;

      // Leave always-open items open
      if (item.classList.contains('always-open')) {
        content.style.display = 'block';
        if (header) header.classList.add('active');
        return;
      }

      if (content !== exceptContent) {
        content.style.display = 'none';
        if (header) header.classList.remove('active');
      }
    });
  }

  function openStep(stepId) {
    const item = document.getElementById(stepId);
    if (!item) return;
    const content = item.querySelector('.accordion-content');
    if (!content) return;

    closeAllAccordionContents(content);
    content.style.display = "block";
    const header = item.querySelector('.accordion-header');
    if (header) header.classList.add('active');
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c];
    });
  }

  // Robustly read a readable label for a radio element
  function getRadioLabelText(radio) {
    if (!radio) return "";
    const ds = radio.dataset || {};
    const keys = ["variantTitle","variant","optionValue","option","optionTitle","title","label","valueText"];
    for (const k of keys) {
      if (ds[k]) return ds[k].trim();
    }
    if (radio.getAttribute && radio.getAttribute("aria-label")) return radio.getAttribute("aria-label").trim();
    if (radio.title) return radio.title.trim();
    if (radio.id) {
      try {
        const lab = document.querySelector('label[for="' + radio.id.replace(/"/g, '\\"') + '"]');
        if (lab) return lab.innerText.trim();
      } catch (e) {}
    }
    const wrapLabel = radio.closest && radio.closest("label");
    if (wrapLabel) return wrapLabel.innerText.trim();
    if (radio.nextSibling && radio.nextSibling.nodeType === Node.TEXT_NODE && radio.nextSibling.textContent.trim()) {
      return radio.nextSibling.textContent.trim();
    }
    if (radio.parentElement) {
      const clone = radio.parentElement.cloneNode(true);
      clone.querySelectorAll("input,button").forEach(n => n.remove());
      const txt = clone.innerText.trim();
      if (txt) return txt;
    }
    return radio.value ? String(radio.value).trim() : "Selected";
  }

  // ---------- Step 1 header setup & dynamic updater ----------
  const step1Header = document.querySelector("#step-1 .accordion-header");
  if (step1Header) {
    const originalTitle = "Choose the size you want";

    function setHeaderForSize(size) {
      if (size) {
        step1Header.innerHTML = `Chosen Size: ${escapeHtml(size)} <span style="color:green; font-weight:700">✔</span>`;
        step1Header.style.backgroundColor = "rgb(206, 244, 202)";
      } else {
        step1Header.innerHTML = originalTitle;
        step1Header.style.backgroundColor = "";
      }
    }

    // Change listener for radios
    document.addEventListener("change", function (e) {
      if (e.target && e.target.matches("#step-1 input[type='radio']")) {
        const labelText = getRadioLabelText(e.target);
        setHeaderForSize(labelText);
        openStep("step-2");
      }
    });

    // Step 1 "Next" button
    const skipStep2 = document.getElementById("skipStep2");
    if (skipStep2) {
      skipStep2.addEventListener("click", function () {
        const selectedRadio = document.querySelector("#step-1 input[type='radio']:checked");
        const sizeLabel = selectedRadio ? getRadioLabelText(selectedRadio) : "";
        setHeaderForSize(sizeLabel);
        openStep("step-2");
      });
    }
  }

  // ---------- Step 2 header setup & dynamic updater ----------
  const step2Header = document.querySelector("#step-2 .accordion-header");
  if (step2Header) {
    const originalStep2Title = "When do you want the flowers?";

    function setHeaderForDate(label) {
      if (label) {
        step2Header.innerHTML = `Chosen Delivery Date: ${escapeHtml(label)} <span style="color:green; font-weight:700">✔</span>`;
        step2Header.style.backgroundColor = "rgb(206, 244, 202)";
      } else {
        step2Header.innerHTML = originalStep2Title;
        step2Header.style.backgroundColor = "";
      }
    }

    // Hook into delivery-card clicks
    document.querySelectorAll(".delivery-card").forEach(card => {
      card.addEventListener("click", function () {
        let label = "";
        const type = card.dataset.type;
        if (type === "today") {
          label = "Today";
        } else if (type === "tomorrow") {
          label = "Tomorrow";
        } else if (type === "custom") {
          label = "Custom Date"; // will be updated when user picks a date
        }
        setHeaderForDate(label);
      });
    });

    // Hook into actual date picker change
    const hiddenDate = document.getElementById("hidden_delivery_date");
    if (hiddenDate) {
      hiddenDate.addEventListener("change", function () {
        if (this.value) {
          setHeaderForDate(this.value);
        }
      });
    }
  }

  // ---------- Step 3 header update on Next button ----------
  const step3Header = document.querySelector("#step-3 .accordion-header");
  if (step3Header) {
    const textarea = document.getElementById("cardMessage");
    const step3NextBtn = document.getElementById("skipStep3");

    function setHeaderForMessage(msg) {
      let preview = msg.trim();
      if (preview.length > 25) preview = preview.substring(0, 25) + "...";

      if (preview === "") preview = "(none)";

      step3Header.innerHTML = `Card Message: ${escapeHtml(preview)} <span style="color:green; font-weight:700">✔</span>`;
      step3Header.style.backgroundColor = "rgb(206, 244, 202)";
    }

    if (step3NextBtn) {
      step3NextBtn.addEventListener("click", function () {
        const msg = textarea ? textarea.value : "";
        setHeaderForMessage(msg);
      });
    }
  }

// ---------- Step 4 header + validation ----------
const step4Header = document.querySelector("#step-4 .accordion-header");
if (step4Header) {
  const firstName = document.getElementById("first_name");
  const lastName = document.getElementById("last_name");
  const contact = document.getElementById("contact_number");
  const address = document.getElementById("address");
  const postcode = document.getElementById("postcode");
  const city = document.getElementById("city");
  const step4NextBtn = document.getElementById("skipStep4");
  const errorBox = document.getElementById("step4Error");

  function setHeaderForRecipient() {
    const fn = firstName ? firstName.value.trim() : "";
    const ln = lastName ? lastName.value.trim() : "";
    const contactVal = contact ? contact.value.trim() : "";
    const addr = address ? address.value.trim() : "";

    let preview = "";
    if (fn || ln) {
      preview = `${fn} ${ln}`.trim();
    } else if (contactVal) {
      preview = contactVal;
    } else if (addr) {
      preview = addr.length > 25 ? addr.substring(0, 25) + "..." : addr;
    } else {
      preview = "(not provided)";
    }

    step4Header.innerHTML = `Recipient: ${escapeHtml(preview)} <span style="color:green; font-weight:700">✔</span>`;
    step4Header.style.backgroundColor = "rgb(206, 244, 202)";
  }

  function validateStep4() {

    const ln = lastName.value.trim();
    const contactVal = contact.value.trim();
    const addr = address.value.trim();
    const pc = postcode.value.trim();
    const cityval = city.value.trim();
   

     const missingFields = [];

  if (!ln) missingFields.push("Last Name");
  if (!contactVal) missingFields.push("Phone");
  if (!addr) missingFields.push("Address");
  if (!pc) missingFields.push("Postcode");
  if (!cityval) missingFields.push("City");

  if (missingFields.length > 0) {
    if (errorBox) {
      errorBox.textContent =
        "Please fill out the following fields: " + missingFields.join(", ");
      errorBox.style.display = "block";
    }
    return false;
  }

    // ✅ Phone number validation (UK format)
    const phoneRegex = /^(?:\+44|0)\d{9,13}$/;
    if (!phoneRegex.test(contactVal)) {
      if (errorBox) {
        errorBox.textContent = "Please enter a valid phone number (e.g. 07123456789 or +447123456789).";
        errorBox.style.display = "block";
      }
      contact.focus();
      return false;
    }

    if (errorBox) errorBox.style.display = "none";
    return true;
  }

  if (step4NextBtn) {
    step4NextBtn.addEventListener("click", function () {
      if (!validateStep4()) return; // stop if invalid
      setHeaderForRecipient();
      openStep("step-5");
    });
  }
}


  // ---------- Step 5 Next ----------
  const step5Header = document.querySelector("#step-5 .accordion-header");
  const step5NextBtn = document.getElementById("skipStep6");

  if (step5Header && step5NextBtn) {
    step5NextBtn.addEventListener("click", function () {
      // Collect selected add-ons
      const selectedAddOns = [];
      document.querySelectorAll("#step-5 .add-on-card.selected").forEach(card => {
        const titleEl = card.querySelector(".title");
        if (titleEl) selectedAddOns.push(titleEl.innerText.trim());
      });

      // Prepare header text
      let headerText = "";
      if (selectedAddOns.length === 0) {
        headerText = "No extras added";
      } else if (selectedAddOns.length === 1) {
        headerText = `Added: ${selectedAddOns[0]}`;
      } else {
        headerText = `Added: ${selectedAddOns.join(", ")}`;
        if (headerText.length > 50) {
          headerText = headerText.substring(0, 50) + "...";
        }
      }

      // Update header
      step5Header.innerHTML = `${escapeHtml(headerText)} <span style="color:green; font-weight:700">✔</span>`;
      step5Header.style.backgroundColor = "rgb(206, 244, 202)";

      // Open next step
      openStep("step-6");
    });
  }

// ---------- Step 6 header update on Next button ----------
const step6Header = document.querySelector("#step-6 .accordion-header");
if (step6Header) {
  const floristNote = document.getElementById("floristNote");
  const step6NextBtn = document.getElementById("skipStep7");

  function setHeaderForFlorist(msg) {
    let preview = msg.trim();
    if (preview.length > 25) preview = preview.substring(0, 25) + "...";

    if (preview === "") preview = "(none)";

    step6Header.innerHTML = `Delivery Instructions: ${escapeHtml(preview)} <span style="color:green; font-weight:700">✔</span>`;
    step6Header.style.backgroundColor = "rgb(206, 244, 202)";
  }

  if (step6NextBtn) {
    step6NextBtn.addEventListener("click", function () {
      const msg = floristNote ? floristNote.value : "";
      setHeaderForFlorist(msg);

      // collapse step 6
      const step6Content = document.querySelector("#step-6 .accordion-content");
      if (step6Content) step6Content.style.display = "none";
      step6Header.classList.remove("active");
    });
  }
}



  // ---------- Accordion header toggle with auto-close ----------
  document.querySelectorAll(".accordion-header").forEach(header => {
    header.addEventListener("click", function () {
      const item = header.parentElement;
      const content = item.querySelector(".accordion-content");
      if (!content) return;

      if (item.classList.contains("always-open")) {
        content.style.display = "block";
        header.classList.add("active");
        return;
      }

      const isOpen = getComputedStyle(content).display === "block";
      if (isOpen) {
        content.style.display = "none";
        header.classList.remove("active");
      } else {
        openStep(item.id);
      }
    });
  });

  // ---------- Delivery / Step 2 logic ----------
const datePicker = document.querySelector("#delivery_date_picker");
const hiddenDate = document.querySelector("#hidden_delivery_date");
const sameDayFeeInput = document.querySelector("#same_day_fee");
const selectedDisplay = document.querySelector("#selected_delivery_date");
const cards = document.querySelectorAll(".delivery-card");

// Config from Liquid
const config = window.deliveryConfig || {};
const cutoffHour = config.cutoffHour || 14; // fallback
let unavailable = [];

// Ensure unavailableDates is always an array
if (Array.isArray(config.unavailableDates)) {
  unavailable = config.unavailableDates;
} else if (typeof config.unavailableDates === "string" && config.unavailableDates.trim() !== "") {
  // Support comma-separated string from Liquid
  unavailable = config.unavailableDates.split(",").map(d => d.trim());
}

// Normalise unavailable to YYYY-MM-DD
unavailable = unavailable.map(d => d.trim());

const hasSameDay = config.hasSameDay === true;

// --- Helpers ---
function formatDate(date) {
  if (!(date instanceof Date) || isNaN(date)) {
    console.warn("Invalid date passed to formatDate:", date);
    return "";
  }
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}


function nowUK() {
  try {
    // Get the current time in London in ISO format
    const iso = new Date().toLocaleString("en-GB", { timeZone: "Europe/London" });
    // Parse it safely
    const parts = iso.split(/[\/, :]/); // [dd, mm, yyyy, hh, mm, ss]
    if (parts.length >= 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);
      return new Date(year, month, day);
    }
  } catch (e) {
    console.error("Failed to parse UK date:", e);
  }
  // fallback to plain Date
  return new Date();
}

function isUnavailable(dateObj) {
  const y = dateObj.getFullYear();
  const m = String(dateObj.getMonth() + 1).padStart(2, '0');
  const d = String(dateObj.getDate()).padStart(2, '0');
  return unavailable.includes(`${y}-${m}-${d}`);
}

(function handleAvailability() {
  const today = nowUK();
  today.setHours(0, 0, 0, 0);

  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const currentHour = nowUK().getHours();

  const todayCard = document.querySelector('.delivery-card[data-type="today"]');
  const tomorrowCard = document.querySelector('.delivery-card[data-type="tomorrow"]');

  const todayStr = config.today; // e.g. "2025-09-15"
  const earliestStr = config.earliestDeliveryDate; // e.g. "2025-09-16"

  // Hide Today card if not available
  if (
    !hasSameDay ||
    currentHour >= cutoffHour ||
    (earliestStr && todayStr !== earliestStr) || // earliest is after today
    isUnavailable(today)
  ) {
    if (todayCard) todayCard.style.display = "none";
  }

  // Hide Tomorrow card if not available
  const tomorrowStr = [
    tomorrow.getFullYear(),
    String(tomorrow.getMonth() + 1).padStart(2, "0"),
    String(tomorrow.getDate()).padStart(2, "0")
  ].join("-");

  if (
    (earliestStr && tomorrowStr < earliestStr) || // tomorrow still before earliest
    isUnavailable(tomorrow)
  ) {
    if (tomorrowCard) tomorrowCard.style.display = "none";
  }
})();

// --- Event listeners for cards ---
cards.forEach(card => {
  card.addEventListener("click", function () {
    cards.forEach(c => c.classList.remove("selected"));
    card.classList.add("selected");

    const type = card.dataset.type;
    const today = nowUK();
    today.setHours(0, 0, 0, 0);

    if (type === "today") {
      const chosenDate = formatDate(today);
      if (sameDayFeeInput) sameDayFeeInput.value = "6.99";
      if (selectedDisplay) selectedDisplay.textContent = "Delivery Today (" + chosenDate + ")";
      console.log("Chosen Date (for display)1:", chosenDate);
      if (hiddenDate) {
        hiddenDate.value = chosenDate;
        hiddenDate.dispatchEvent(new Event('change'));
      }
      openStep("step-3");

    } else if (type === "tomorrow") {
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      const chosenDate = formatDate(tomorrow);
      console.log("Chosen Date (for display):", chosenDate);
      if (sameDayFeeInput) sameDayFeeInput.value = "";
      if (selectedDisplay) selectedDisplay.textContent = "Delivery Tomorrow (" + chosenDate + ")";
      if (hiddenDate) {
        hiddenDate.value = chosenDate;
        hiddenDate.dispatchEvent(new Event('change'));
      }
      openStep("step-3");

    } else if (type === "custom") {
  if (sameDayFeeInput) sameDayFeeInput.value = "";
  if (datePicker && datePicker.closest) datePicker.closest(".custom-date").style.display = "block";
  if (selectedDisplay) selectedDisplay.textContent = "Please select a date";

  if (hiddenDate) {
    // Reset hidden date
    hiddenDate.value = "";
    hiddenDate.dispatchEvent(new Event('change'));
  }

  // ✅ Auto-select first available date
  if (window.firstAvailableUK && datePicker) {
    const formatted = formatDate(window.firstAvailableUK); // reuse your formatDate function
    datePicker.value = formatted;
    hiddenDate.value = formatted;
    hiddenDate.dispatchEvent(new Event('change'));

    if (selectedDisplay) selectedDisplay.textContent = "Selected Delivery Date: " + formatted;
  }
}
  });
});

if (hiddenDate) {
  hiddenDate.addEventListener('change', function () {
    const value = this.value;
    if (value) {
      // Only change text if it’s still in “Please select a date” state (custom date)
      if (selectedDisplay && selectedDisplay.textContent.includes("Please select")) {
        selectedDisplay.textContent = "Selected Delivery Date: " + value;
      }
      openStep("step-3");
    }
  });
}






  // ---------- Step 3 Next ----------
  const skipBtn = document.getElementById("skipStep3");
  if (skipBtn) skipBtn.addEventListener("click", function () { openStep("step-4"); });

  // ---------- Char counter ----------
  const textarea = document.getElementById('cardMessage');
  const charCount = document.getElementById('charCount');
  if (textarea && charCount) {
    textarea.addEventListener('input', function () {
      charCount.textContent = `${textarea.value.length} / 200 characters`;
    });
  }

  // ---------- Add-ons select ----------
  document.querySelectorAll(".add-on-card").forEach(card => {
    card.addEventListener("click", function () {
      const input = this.querySelector("input[type='hidden']");
      this.classList.toggle("selected");
      if (input) input.disabled = !this.classList.contains("selected");
    });
  });

 // --- Update Step 2 card labels with actual dates (UK time) ---
// --- Update Step 2 card labels with actual dates (UK time) ---
(function updateDeliveryCardLabels() {
  // Toggle: false = "dd-mm-yy" (03-11-25), true = long format (November 3, 2025)
  const useLongFormat = false;

  function pad(n) { return String(n).padStart(2, '0'); }

  // Format dd-mm-yy
  function formatShortUK(dateObj) {
    // dateObj should already represent the correct UK date (year,month,day)
    const day = pad(dateObj.getDate());
    const month = pad(dateObj.getMonth() + 1);
    const year = String(dateObj.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  }

  // Format long e.g. "November 3, 2025" (locale locked to en-GB but month in English)
  function formatLongUK(dateObj) {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/London",
      year: "numeric",
      month: "long",
      day: "numeric"
    }).format(dateObj);
  }

  // Build a Date object representing UK midnight today
  function getTodayUKMidnight() {
    // Example toLocaleString result: "03/11/2025, 22:00:00" -> split on comma, take date part "03/11/2025"
    const localised = new Date().toLocaleString("en-GB", { timeZone: "Europe/London" });
    const datePart = localised.split(",")[0].trim(); // "DD/MM/YYYY"
    const parts = datePart.split("/").map(p => parseInt(p, 10));
    if (parts.length >= 3 && !parts.some(isNaN)) {
      const [d, m, y] = parts;
      return new Date(y, m - 1, d); // local Date constructed from UK Y/M/D at midnight local-time representation
    }
    // fallback: use now and zero hours
    const f = new Date();
    f.setHours(0, 0, 0, 0);
    return f;
  }

  const todayUK = getTodayUKMidnight();
  const tomorrowUK = new Date(todayUK);
  tomorrowUK.setDate(todayUK.getDate() + 1);

  const todayStrong = document.querySelector('.delivery-card[data-type="today"] strong');
  const tomorrowStrong = document.querySelector('.delivery-card[data-type="tomorrow"] strong');

  if (todayStrong) {
    todayStrong.textContent = useLongFormat
      ? `Delivery Today (${formatLongUK(todayUK)})`
      : `Delivery Today (${formatShortUK(todayUK)})`;
  }
  if (tomorrowStrong) {
    tomorrowStrong.textContent = useLongFormat
      ? `Delivery Tomorrow (${formatLongUK(tomorrowUK)})`
      : `Delivery Tomorrow (${formatShortUK(tomorrowUK)})`;
  }
})();



  
});